import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { LazyComponent } from '#src/app/shared/components/layout/lazy';

import type { SignFormProps } from './SignForm';
import type { SignFormContainerRefreshWrapperContainer } from './SignFormContainerRefreshWrapper';

async function loadSignForm(): Promise<typeof SignFormContainerRefreshWrapperContainer> {
	return (await import(/* webpackChunkName: "pages/petitionDetails-signForm" */ './SignFormContainerRefreshWrapper'))
		.SignFormContainerRefreshWrapperContainer;
}

export const SignFormLoader: React.FC<SignFormProps> = (props) => {
	return (
		<LazyComponent loadComponent={loadSignForm} fallback={<Spinner className="mx-auto mt-16 size-6" />} {...props} />
	);
};

export const preloadSignForm = loadSignForm;
